import * as z from 'zod/mini';
import { DateISO } from '../schema/DateISO.js';
import { defineFormInput } from './defineFormInput.js';
/**
 * Schema for birth date input configuration.
 */
export const BirthDateInput = defineFormInput({
    type: 'BIRTH_DATE',
    input: {
        question: z.string(),
        help: z.optional(z.string()),
    },
    value: {
        date: DateISO,
    },
});
//# sourceMappingURL=BirthDateInput.js.map